import React from 'react';
import Grid from '@material-ui/core/Grid';
import Form from '../components/creatOffer/Form';
import Table from '../components/creatOffer/Table';
import Drawer from '../components/Drawer';

function CreateOffer() {
  return (
    <Drawer>
      <Grid container justify="flex-start" style={{ width: '90vw' }}>
        <Grid item md={12} sm={12}>
          <Form />
        </Grid>
        <Grid item md={12} sm={12}>
          <Table />
        </Grid>
      </Grid>
    </Drawer>
  );
}

export default CreateOffer;
